import styled from 'styled-components';
import { borderRadius, borderWidth1, borderColors } from 'ui/theme';
import type { AuroraContainerProps } from './types';

export const AuroraContainer = styled.div<AuroraContainerProps>`
  &[data-bordered='bordered'] {
    border: ${borderWidth1} ${borderColors.borderPrimary};
  }
  &[data-size='large'] {
    border-radius: ${borderRadius.xxl};
  }
  &[data-size='medium'] {
    border-radius: ${borderRadius.xl};
  }
  &[data-size='small'] {
    border-radius: ${borderRadius.md};
  }
`;
